import { render, staticRenderFns } from "./workspace_state_indicator.vue?vue&type=template&id=7b8810f8"
import script from "./workspace_state_indicator.vue?vue&type=script&lang=js"
export * from "./workspace_state_indicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports